import { useEffect, useState, Dispatch, SetStateAction } from 'react';
import { debounce } from 'lodash-es';

type ScrollEventParams = {
  setTopBarVisibility: (value: boolean) => void;
  setPos: Dispatch<SetStateAction<number>>;
};

const scrollEvent =
  ({ setTopBarVisibility, setPos }: ScrollEventParams) =>
  () => {
    let scrollDirection = 'down';
    const header = document.querySelector('#header') as HTMLElement | null;
    const purchaseCont = document.querySelector(
      '#purchaseCont',
    ) as HTMLElement | null;

    if (purchaseCont == null || header == null) return;

    const purchaseContPos = purchaseCont?.getBoundingClientRect().top || null;
    const purchaseContStylePos = window.getComputedStyle(purchaseCont).position;

    setPos((prevPos: number | null) => {
      if (purchaseContPos === null) return Infinity;

      if (prevPos !== null && prevPos > purchaseContPos)
        scrollDirection = 'down';
      else scrollDirection = 'up';

      return purchaseContPos;
    });

    const resetHeaderView = () => {
      header.style.transform = 'translateY(0)';
      setTopBarVisibility(false);
    };

    if (purchaseContStylePos === 'fixed') {
      resetHeaderView();

      return;
    }

    if (purchaseContPos !== null) {
      if (purchaseContPos <= 40 && scrollDirection === 'down') {
        header.style.transform = 'translateY(-100%)';
        setTopBarVisibility(true);
      } else {
        resetHeaderView();
      }
    }
  };

export default function usePageScrollEvent() {
  const [, setPos] = useState(Infinity);
  const [showTopBar, setTopBarVisibility] = useState(false);
  const debuncedScroll = debounce(
    scrollEvent({ setTopBarVisibility, setPos }),
    50,
  );

  useEffect(() => {
    window.addEventListener('scroll', debuncedScroll);

    return () => {
      const header = document.querySelector('#header') as HTMLElement | null;

      setTopBarVisibility(false);
      if (header != null) header.style.transform = 'translateY(0)';
      window.removeEventListener('scroll', debuncedScroll);
    };
  }, []);

  return {
    shouldShowTopBar: showTopBar,
  };
}
